<template>
  <div class="history">
    <!-- <span class="font-red">Each documents will be available for re-download for 72 hours, just click Re-download</span>
    <el-tabs v-model="currentValue" class="tabs-list" >
      <el-tab-pane
        v-for="(o,oIndex) in tabList"
        :key="o.label"
        :label="o.label"
        :name="o.name"
        class="tabs-content"
        v-if="currentValue === o.name"
        v-loading="tableLoading">
        <Table :obj="o.data" @sizeChange="sizeChange" @pageChange="pageChange" />
      </el-tab-pane>
    </el-tabs> -->
    <TabTitle title="History" />
    <div class="table-container">
      <Table
        :obj="tabList[0].data"
        @sizeChange="sizeChange"
        @pageChange="pageChange"
      />
    </div>

    <DialogList
      :dialogVisible="dialogTableVisibleNew"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />


  </div>
</template>

<script>
import Table from "./module/table.vue";
import { getConsumeList } from "@/api/order";
import TabTitle from "@/components/TabTitle.vue";
import DialogList from "../materialDownload/module/dialog.vue";
import Accountdialog from "../materialDownload/module/accountdialog";

export default {
  components: {
    Table,
    TabTitle,
    DialogList,
    Accountdialog,
  },
  data() {
    return {
      currentValue: "first",
      tabList: [
        {
          label: "History",
          name: "first",
          data: {},
        },
      ],
      tableLoading: false,
      pageNo: 1,
      pageSize: 10,
      dialogTableVisibleNew: false,
      accountDialogTableVisible: false,
    };
  },
  mounted() {
    this.$EventBus.$on("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$on("accountDetailOut", this.openAccountDetailPop);
    this.getTableDatas();
    this.initGoogleAnalytics();
  },
  beforeDestroy() {
    this.$EventBus.$off("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$off("accountDetailOut", this.openAccountDetailPop);
  },
  methods: {
    // 初始化 Google Analytics
    initGoogleAnalytics() {
      window.dataLayer = window.dataLayer || [];
      const gtag = (...args) => dataLayer.push(args);
      gtag("js", new Date());
      gtag("config", "UA-78962210-9");
    },

    async getTableDatas() {
      this.tableLoading = true;
      try {
        const promises = this.tabList.map((item, index) => {
          const dataform = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            orderType: index + 1,
          };
          return getConsumeList(dataform).then((result) => {
            item.data = result;
          });
        });
        await Promise.all(promises);
      } catch (error) {
        console.error("Get table data error:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    pageChange(params) {
      this.pageNo = params;
      this.pageSize = 10;
      this.getTableDatas();
    },

    sizeChange(param) {
      this.pageSize = param;
      this.pageNo = 1;
      this.getTableDatas();
    },

    openConstDetailPop() {
      this.dialogTableVisibleNew = true;
    },

    closeConstDetailPop() {
      this.dialogTableVisibleNew = false;
    },

    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },

    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.font-red {
  color: #909399;
  // float: right;
  // margin-top: 12px;
}

.el-tabs--card.download-history-tabs {
  > .el-tabs__header,
  > .el-tabs__header .el-tabs__item,
  > .el-tabs__header .el-tabs__nav {
    border: none;
  }
}

.table-container {
  background-color: white;
}
</style>
